import { memo } from 'react';
//Local files
import { Label, Wrapper } from './NavItem.styled';

const NavItem = ({ id, icon, label, active, onDragStart }) => {
  return (
    <div
      id={id}
      style={{ height: 80, width: 80, cursor: 'pointer' }}
      draggable
      onDragStart={onDragStart}
    >
      <Wrapper active={active}>
        {icon}
        <Label>
          {label}
        </Label>
      </Wrapper>
    </div>
  )
}

export default memo(NavItem);